module.exports = __webpack_public_path__ + "img/cn.23540ba7.svg";